module.exports = __webpack_public_path__ + "img/26_166.2ad55171.png";